import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../api';
import toast from 'react-hot-toast';

export const EntriesContext = createContext();

export const EntriesProvider = ({ children }) => {
  const [entries, setEntries] = useState([]);

  const fetchEntries = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_BASE_URL}/api/entries`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setEntries(res.data);
    } catch (error) {
      toast.error('Failed to load entries');
    }
  };

  const updateEntry = async (id, data) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${API_BASE_URL}/api/entries/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchEntries();
    } catch (error) {
      toast.error('Failed to update entry');
    }
  };

  const deleteEntry = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_BASE_URL}/api/entries/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      fetchEntries();
    } catch (error) {
      toast.error('Failed to delete entry');
    }
  };

  useEffect(() => {
    fetchEntries();
  }, []);

  return (
    <EntriesContext.Provider value={{ entries, setEntries, fetchEntries, updateEntry, deleteEntry }}>
      {children}
    </EntriesContext.Provider>
  );
};
